import React, { useState } from 'react';
import { Search, Clock, MapPin, Camera, ArrowRight, ChevronRight, Shield, Bell, DollarSign } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const OnboardingScreen = () => {
  const [currentScreen, setCurrentScreen] = useState(0);
  const navigate = useNavigate();

  const screens = [
    {
      icon: Search,
      title: "Vulcanizare mobilă la un click distanță!",
      features: [
        { icon: Search, text: "Găsești vulcanizarea mobilă disponibilă cel mai aproape de tine" },
        { icon: MapPin, text: "Trimite locația ta exactă fără apeluri și explicații inutile" },
        { icon: Camera, text: "Poți adăuga imagini cu problema, ca tehnicianul să fie pregătit din start" }
      ],
      cta: "Începe acum și vezi cât de simplu e!"
    },
    {
      icon: Clock,
      title: "Asistență 24/7, oriunde te afli!",
      features: [
        { icon: Clock, text: "Ai pană la miezul nopții? Nu-i nimic! Vulcanizările noastre partenere sunt disponibile 24/7" },
        { icon: Search, text: "Mai mulți parteneri în rețea înseamnă că există întotdeauna cineva gata să te ajute" },
        { icon: Clock, text: "Timp de răspuns rapid – găsim cel mai apropiat specialist și îl trimitem direct la tine" }
      ],
      cta: "Suntem aici pentru tine, la orice oră!"
    },
    {
      icon: Shield,
      title: "Servicii sigure, fără surprize!",
      features: [
        { icon: DollarSign, text: "Vezi în aplicație prețul estimativ înainte să comanzi" },
        { icon: Bell, text: "Primești notificări în timp real: vezi când ajunge tehnicianul la tine" },
        { icon: Shield, text: "Fără stres – noi ne asigurăm că problema e rezolvată rapid și corect" }
      ],
      cta: "Comandă acum și experimentează viitorul vulcanizării mobile!"
    }
  ];

  const currentScreenData = screens[currentScreen];

  const goToNextScreen = () => {
    if (currentScreen < screens.length - 1) {
      setCurrentScreen(currentScreen + 1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Progress Indicator */}
      <div className="fixed top-6 left-0 right-0 flex justify-center gap-2">
        {screens.map((_, index) => (
          <div
            key={index}
            className={`h-1 rounded-full transition-all duration-300 ${
              index === currentScreen ? 'w-8 bg-blue-600' : 'w-2 bg-gray-200'
            }`}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center space-y-8">
        {/* Icon */}
        <div className="w-32 h-32 bg-blue-100 rounded-full flex items-center justify-center">
          <currentScreenData.icon className="w-16 h-16 text-blue-600" />
        </div>
        
        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 max-w-sm">
          {currentScreenData.title}
        </h1>

        {/* Features */}
        <div className="w-full max-w-md space-y-4">
          {currentScreenData.features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex items-start gap-4"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <feature.icon className="w-6 h-6 text-blue-600" />
              </div>
              <p className="flex-1 text-left text-gray-600">
                {feature.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="p-6 bg-white border-t border-gray-100">
        <button
          onClick={goToNextScreen}
          className="w-full bg-blue-600 text-white py-4 rounded-xl font-medium hover:bg-blue-700 transition-colors flex items-center justify-center"
        >
          {currentScreen === screens.length - 1 ? (
            <>
              Începe să folosești aplicația
              <ArrowRight className="ml-2 w-5 h-5" />
            </>
          ) : (
            <>
              {currentScreenData.cta}
              <ChevronRight className="ml-2 w-5 h-5" />
            </>
          )}
        </button>

        {currentScreen < screens.length - 1 && (
          <button
            onClick={() => setCurrentScreen(screens.length - 1)}
            className="w-full mt-4 text-gray-500 text-sm"
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
};

export default OnboardingScreen;